import axios from 'axios';
import normalize from 'Utils/normalizer';
import errorHandler from 'Utils/error-handler';
import useSession from 'Hooks/session.hook';
import { getWithExpiry } from 'Helpers/getset-with-expiry';
import { getAccessToken } from 'Helpers/session';
import { toLower, omitBy, isEmpty, isNil, map, some } from 'lodash';

interface Filters {
  orgID?: string;
  orgType?: string;
  roleType?: string;
  roleSubType?: string;
  onlyActive?: boolean;
  status?: string;
  fetchUserOfChildren?: boolean;
}

interface Pagination {
  offset: number;
  limit: number;
}

interface Sorting {
  sortBy: string;
  mode: string;
}

interface Phone {
  dialCode: string;
  number: string;
}

// interface Data {
//   _id: string;
//   profileID: string;
//   fullName: string;
//   identificationType?: string;
//   identificationNumber?: string;
//   identificationIssueDate: moment.Moment | null;
//   identificationExpiryDate: moment.Moment | null;
//   identificationPlaceOfIssue?: string;
//   addressLine1: string;
//   addressLine2?: string;
//   city: string;
//   state: string;
//   postcode: string;
//   country: string;
//   email: string;
//   contactNumber: Phone;
//   gender?: string;
//   dob?: moment.Moment | null;
//   roles?: any[];
// }

interface List {
  filters: Filters;
  pagination?: Pagination;
  sorting?: Sorting;
}

export const getUserList = async ({
    filters,
    pagination,
    sorting
  }: List) => {
    const url = `${process.env.API_URL}/${process.env.API_VER}/org/user/list`;
    const session = getWithExpiry(process.env.APP_SESSION);
    // const { accessToken } = JSON.parse(session || '{}');
    const accessToken = getAccessToken();
    const { org } = useSession();
  
    const orgType: string = (org.orgType || []).indexOf('OWNER') >= 0 ? 'OWNER' : org.orgType[0] || null;
  
    if (!isNil(orgType)) {
      filters.orgType = orgType;
    }
  
    try {
      const response = await axios({
        method:'POST',
        url: url,
        data: omitBy({ filters: filters, pagination, sorting }, isNil),
        headers: {'Authorization': `Bearer ${accessToken}`}
      });
  
      return !isEmpty(response.data.users) ?
        map(response.data.users, (user: any) => {
          return normalize.response.account(user)
        }) : [];
    }
    catch(err:any) {
      const { error } = err.response?.data || {};
  
      if (!isEmpty(error)) {
        const callback = async () => {
          const result = await getUserList({ filters, pagination, sorting });
          return result;
        };
        const { value, code, message, stack } = await errorHandler.response(error, { callback });
        return { error: { value, code, message, stack }};
      }
      else {
        console.log(err.message)
        return { error: { message: err.message }};
      }
    }
  }


export const getCompanyList = async (orgID?: string) => {
    const url = `${process.env.API_URL}/${process.env.API_VER}/org/company/list`;
    const accessToken = getAccessToken();
    const {org} = useSession();
  
    try {
      const response = await axios({
        method:'POST',
        url: url,
        data: {orgID: orgID ? orgID : org.logisticProviderOrgID},
        headers: {'Authorization': `Bearer ${accessToken}`}
      });
  
      return response.data.orgs;
    }
    catch(err: any) {
      const { error } = err.response?.data || {};
  
      if (!isEmpty(error)) {
        const callback = async () => await getCompanyList(orgID);
        const { value, code, message, stack } = await errorHandler.response(error, callback());
        return { error: { value, code, message, stack }};
      }
      else {
        console.log(err.message)
        return { error: { message: err.message }};
      }
    }
}

export const getLogisticProviderList = async () => {
    const url = `${process.env.API_URL}/${process.env.API_VER}/org/logistic_provider/list`;
    const accessToken = getAccessToken();
    const { org } = useSession();
  
    try {
      const response = await axios({
        method:'POST',
        url: url,
        data: {orgID: org._id},
        headers: {'Authorization': `Bearer ${accessToken}`}
      });
  
      return response.data.orgs;
    }
    catch(err: any) {
      const { error } = err.response?.data || {};
  
      if (!isEmpty(error)) {
        const callback = async () => await getLogisticProviderList();
        const { value, code, message, stack } = await errorHandler.response(error, callback());
        return { error: { value, code, message, stack }};
      }
      else {
        console.log(err.message)
        return { error: { message: err.message }};
      }
    }
  }